import React from 'react'
import WebView from '~co/common/webview'
import useWithWebView from '~co/highlights/useWithWebView'

export default function PageMyItemTabWeb({ item: { _id, link }, webViewRef }) {
	useWithWebView(webViewRef, _id)

    return (
		<WebView 
			ref={webViewRef}
			className={'ui-tab-web'} 
			src={link} />
	)
}